import React, { useState }  from 'react';
import styles from 'components/show_drawing/redraw_form/_style.module.scss';
import Constants from 'components/show_drawing/Constants.jsx';
import MyEventListener from 'components/common/MyEventListener.jsx'
import renderOption from 'components/show_drawing/redraw_form/options/renderOption.jsx';

const OptionWithChildren = ( { id, drawing, option, unit, addToOptionsUserChanged, optionsUserChanged, setRedrawRequested, labelGroup = 'dimensions', inputName } ) => {
  const [childrenHidden, setChildrenHidden] = useState(true)
  // Mirror the visibility tracking the other option leaves do via
  // OptionsCommon, so a hidden parent-with-children doesn't render its
  // outer .booleanGridItemWide div (which would claim a full grid row and
  // re-introduce the empty-cell gap the leaf-owned-width model was meant
  // to fix). Initial state from option.visible, runtime updates from the
  // same drawing_option_visible_updated event OptionsCommon subscribes to.
  const [isVisible, setIsVisible] = useState(option.visible !== false)
  const onSelfVisibleChangedMsg = (msg) => {
    if (msg.detail.drawing_id == id && msg.detail.name == option.name) {
      setIsVisible( () => msg.detail.visible )
    }
  }

  const onRecoverySerValueHighlightMsg = (msg) => {
    if(msg.detail.id != id) { return; }
    const rule = msg.detail.rule;
    const apply_to_names = (rule.recovery_apply_to || []).map(recovery => recovery.name);
    const isOurChild = option.children.some(child => apply_to_names.includes(child.name));
    if(isOurChild) {
      setChildrenHidden( () => false )
    }
  }

  // Render the parent option itself as a leaf (by its input_type) without
  // losing option.children — the leaf components read option.children to
  // decide whether to render the Show/Hide children button.
  const renderSelf = () => renderOption({
    id,
    drawing,
    option,
    unit,
    optionsUserChanged,
    addToOptionsUserChanged,
    setRedrawRequested,
    labelGroup,
    inputName,
    renderAsLeaf: true
  })

  const renderChild = (child) => renderOption({
    id,
    drawing,
    option: child,
    unit,
    optionsUserChanged,
    addToOptionsUserChanged,
    setRedrawRequested,
    labelGroup
    // inputName intentionally not propagated: children carry their own names.
    // renderOption throws when inputName is set alongside children anyway.
  })

  const childOptionVisibleChangeMsg = (msg) => {
    if(msg.detail.id == id && msg.detail.name == option.name) {
      setChildrenHidden( () => !msg.detail.visible )
    }
  }

  // useEffect
  MyEventListener([
    {
      key: Constants.child_options_visible_change,
      callback: childOptionVisibleChangeMsg
    },{
      key: Constants.drawing_recovery_set_value_highlight_required,
      callback: onRecoverySerValueHighlightMsg,
    },{
      key: Constants.drawing_option_visible_updated,
      callback: onSelfVisibleChangedMsg,
    }
  ])
  // useEffect

  // When hidden, skip the outer wrapper entirely. renderSelf() returns the
  // leaf component, which is also tracking its own isVisible via
  // OptionsCommon and returns <input type="hidden"> for the form. The
  // hidden input is display:none and falls out of the grid layout, so we
  // don't claim a half-row gap next to a sibling boolean.
  if (!isVisible) { return renderSelf() }

  // Always span the full grid row when visible — the parent leaf plus a
  // disclosure of children is too much vertical content to share a
  // half-cell. .booleanGridItemWide is grid-only, so this wrapper is inert
  // when OptionWithChildren is rendered outside .booleanGrid (e.g. by
  // ComboButtonsSection).
  return (
    <div className={styles.booleanGridItemWide}>
      {renderSelf()}
      {!childrenHidden && <div className={styles.child_option}> {option.children.map(renderChild)} </div> }
    </div>
  )
}

export default OptionWithChildren;
